import { gtcDebounce } from "./gtc-utils.js";
const productCardImageSelector = ".product-item__primary-image";

/************************* *Content block  *************************/
class ContentBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.dom = {
      container: this.querySelector(".gtc-content-block__media-container"),
    };

    if (this.hasAttribute("reveal")) {
      this.showOnIntersection();
    }

    if (this.hasAttribute("match-product-image-height")) {
      this.init();
    }
  }

  init() {
    const productImage = this.parentElement.querySelector(
      productCardImageSelector
    );
    if (!productImage) {
      return;
    }

    const setContainerHeight = () => {
      this.style.setProperty('--match-product-image-height', productImage.getBoundingClientRect().height + "px");
    }


    const handleResize = gtcDebounce(() => {
      setContainerHeight();
    }, 10);

    window.addEventListener("resize", handleResize);

    setContainerHeight();

  }

  showOnIntersection() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => {
            this.removeAttribute("reveal");
          });

          intersectionObserver.unobserve(this);
        }
      });
    };

    const intersectionObserver = new IntersectionObserver(callback, options);
    intersectionObserver.observe(this);
  }
}

if (!customElements.get("gtc-content-block")) {
  customElements.define("gtc-content-block", ContentBlock);
}

class VideoAutoplay extends HTMLElement {
  constructor() {
    super();

    this.videoElement = null;
    this.intersectionObserver = null;
  }

  connectedCallback() {
    this.videoElement = this.querySelector('video');
    if (this.videoElement) {
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0 });
      this.intersectionObserver.observe(this.videoElement);
    }

  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.videoElement);
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    const isVisible = entries[0].isIntersecting;
    if (isVisible) {
      this.playVideo();
      console.log('play');
    } else {
      this.pauseVideo();
      console.log('pause');
    }
  }

  playVideo() {
    if (this.videoElement) {
      this.videoElement.play();
    }
  }

  pauseVideo() {
    if (this.videoElement) {
      this.videoElement.pause();
    }
  }
}

if (!window.customElements.get('video-autoplay')) {
  customElements.define('video-autoplay', VideoAutoplay);
}
